import { render, staticRenderFns } from "./LinksCard.vue?vue&type=template&id=d0d229f6&"
import script from "./LinksCard.vue?vue&type=script&lang=js&"
export * from "./LinksCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports